/* global I18n */

import React, {useState} from "react"
import FaIcon from "components/fa_icon"
import ExamSummaryModal from "./exam_summary_modal"

function ExamSummary({
  exam_training_stats,
  revise_exam_quiz,
  can_train
}) {
  const is_passed = exam_training_stats.success_rate >= 60
  const status = is_passed ? "passed" : "failed"
  const [summary_modal_is_open, set_summary_modal_is_open] = useState(false)
  const [summary_filter, set_summary_filter] = useState()
  const exercises = exam_training_stats.exercises
  const answered_correctly = exercises.filter(
    exercise => exercise.answer_status === "success"
  )
  const answered_incorrectly = exercises.filter(
    exercise => exercise.answer_status === "failed"
  )
  const not_answered = exercises.filter(
    exercise => exercise.answer_status === "skipped" ||
      exercise.answer_status === null
  )

  function view_summary(filter) {
    set_summary_modal_is_open(true)
    set_summary_filter(filter)
  }

  function on_link_click() {
    revise_exam_quiz(
      "exam_mode",
      {exercises: answered_incorrectly.map(ex => ex.id)}
    )
  }

  return (
    <div>
      <div className={`results-container ${status}`}>
        <div className="text">
          <div className="title">
            {I18n.t(`js.embedded_quiz.exam_summary.${status}_title`)}
          </div>
          <div className="description">
            {I18n.t(
              `js.embedded_quiz.exam_summary.${status}_description_1`
            )}
            <br/>
            {!is_passed && !!answered_incorrectly.length &&
              <>
                <a onClick={on_link_click}>
                  {I18n.t("js.embedded_quiz.exam_summary.failed_link")}
                </a>
                {I18n.t(
                  "js.embedded_quiz.exam_summary.failed_description_2"
                )}
              </>}
            {is_passed &&
              I18n.t("js.embedded_quiz.exam_summary.passed_description_2")}
          </div>
        </div>
        <div className="stats">
          <div className="stat">
            <div className="figure">{exam_training_stats.success_rate}%</div>
            <div className="legend">
              {I18n.t("js.embedded_quiz.exam_summary.success_rate")}
            </div>
          </div>
          <div className="stat">
            <div className="figure">{exam_training_stats.practice_time}</div>
            <div className="legend">
              {I18n.t("js.embedded_quiz.exam_summary.total_time")}
            </div>
          </div>
          <div className="stat">
            <div className="figure">
              {exam_training_stats.time_per_question}
            </div>
            <div className="legend">
              {I18n.t("js.embedded_quiz.exam_summary.per_question")}
            </div>
          </div>
        </div>
        <div className="counters">
          <div className="counter correct">
            <FaIcon name="fa-check"/>
            <span>{answered_correctly.length}</span>
            {I18n.t("js.embedded_quiz.exam_summary.correct")}
          </div>
          <div className="counter incorrect">
            <FaIcon name="fa-times"/>
            <span>{answered_incorrectly.length}</span>
            {I18n.t("js.embedded_quiz.exam_summary.incorrect")}
          </div>
          <div className="counter skipped">
            <FaIcon name="fa-minus"/>
            <span>{not_answered.length}</span>
            {I18n.t("js.embedded_quiz.exam_summary.skipped")}
          </div>
          <button className="btn btn-small btn-light"
                onClick={() => view_summary()}>
            {I18n.t("js.embedded_quiz.exam_summary.view_summary")}
            <FaIcon name="fa-arrow-right"/>
          </button>
        </div>
        <div className="last-quiz">
          {I18n.t("js.embedded_quiz.exam_summary.last_quiz")}
          <span className="timestamp">
            {I18n.t("js.embedded_quiz.time_ago",
              {time: exam_training_stats.last_exam_quiz_in_words})}
          </span>
        </div>
      </div>
      <ExamSummaryModal
        is_open={summary_modal_is_open}
        on_close={() => set_summary_modal_is_open(false)}
        filter={summary_filter}
        exercises={exercises}
        revise_exam_quiz={revise_exam_quiz}
        can_train={can_train}
      />
    </div>
  )
}

export default ExamSummary
